@if (input) {
  <div
    class="input-submit-button-wrapper"
    [ngClass]="{ 'input-submit-button--max-width': isMaxWidth }"
  >
    <button
      id="{{ input.id }}"
      type="{{ input.type ? input.type : 'submit' }}"
      class="input-submit-button"
      [ngClass]="{
        'input.class': input.class,
        small: small,
        middle: middle,
        orange: orange,
      }"
      (click)="input.onclick ? input.onclick() : ''"
      [disabled]="input.disabled"
      [innerHTML]="input.value | translate"
      data-cy="InputSubmit"
    ></button>
  </div>
}
